<template>
  <div>
     <div class="login"  style="margin-top: 40px !important;">
    
   <el-card style="border-top: 3px solid #ff8177;" v-loading="loadingMsj" width="30%">
        <img src="@/assets/fo_logo.png" alt />
        <center><h3><i class="el-icon-lock"></i> Recuperar contraseña</h3></center>
        <div v-if="msj_show !='' && !loadingMsj && !noShow">
            <img src="@/assets/ico_rechazado.png" alt="">
            <p   style="margin-bottom: -5px !important;text-align:center">{{msj_show}}</p>
            <el-button style="border-color: #ffffff;margin-top: 15px;" class="btn-block"       
                    @click="regresarLink"><i class="el-icon-back" ></i> Volver</el-button>
        </div>  
        <div  v-if="msj_show=='' && !loadingMsj && !noShow"> 
        <p style="text-align:center;margin-bottom:-5px;">A continuación ingrese una nueva contraseña para su cuenta.</p>
        <el-form :model="ruleForm" status-icon label-position="top" :rules="rules" ref="ruleForm" class="demo-ruleForm">
            <el-form-item label="Nueva Contraseña" prop="pass">
                <el-input type="password" show-password v-model="ruleForm.pass" ref="password1" autocomplete="off"><template slot="prepend"><i class="el-icon-lock"></i></template></el-input>
            </el-form-item>
            <el-form-item label="Repetir Contraseña" prop="checkPass">
                <el-input type="password"  show-password v-model="ruleForm.checkPass" autocomplete="off" @keypress.native.enter="recuperar('ruleForm')"><template slot="prepend"><i class="el-icon-unlock"></i></template></el-input>
            </el-form-item>
            <el-form-item >
                <center>
                    <el-button type="primary" class="btn-block" @click="recuperar('ruleForm')" 
                    :loading="loadin_enviar" style="margin-top:10px !important;"><i class="el-icon-lock" ></i> Guardar
                    </el-button>
                    <el-tooltip class="item" effect="dark" content="Volver a login" placement="right-end">
                    <el-button style="border-color: #ffffff;margin: 0px;margin-bottom:-10px !important" 
                    class="btn-block" @click="regresarLink"><i class="el-icon-back" ></i> Volver</el-button>
                    </el-tooltip>            
                </center>
            </el-form-item>

        </el-form>
        </div>
        <div v-if="noShow && !loadingMsj">
            <img :src="imgResultado" alt="">
            <p style="text-align: center;">{{msj_show}}</p>
            <el-button class="btn-block" type="primary" @click="regresarLink"><i class="el-icon-back"></i>Regresar</el-button>
        </div>
        
        
   </el-card>
    </div>
  </div>
</template>
<script>
import { EventBus } from "@/event-bus";
import { HTTP,SC_prueba} from "@/axios.js";

export default {
    data() {
        var validatePass = (rule, value, callback) => {
            if (value === '') {
            callback(new Error('Ingrese una contraseña'));

            }  else {
                if (this.ruleForm.checkPass !== '') {
                    this.$refs.ruleForm.validateField('checkPass');
                }
                callback();
            }
            
        };
        var validatePass2 = (rule, value, callback) => {
            if (value === '') {
            callback(new Error('Ingrese una contraseña'));
            } else if (value !== this.ruleForm.pass) {
            callback(new Error('Las contraseñas no coinciden!'));
            } else {
            callback();
            }
        };
        return {
            showForm:false,
            loadin_enviar:false,
            titulo:'',
            imgFavicon:'',
            showbtnC:'',
            empresa:'',
            ruleForm: {
                pass: '',
                checkPass: '',
            },
            rules: {
                pass: [
                    { validator: validatePass, trigger: 'blur' }
                ],
                checkPass: [
                    { validator: validatePass2, trigger: ['change','blur'] }
                ],
            },
            codigo:false,
            noShow:'',
            msj_show:'',
            imgResultado:'',
            btnRegresar:'',
            loadingMsj:true
        }
    },
     created() {
    /* Imagen segu url y btn */
    // Mostrar los datos según la url
    /* ----- */
    if(this.$route.query.s !='')
    {
        this.codigo     = this.$route.query.s;
        this.loadingMsj = true
        HTTP.post(SC_prueba+'/verificarSalt',{codigo:this.codigo}).then( 
            res=>{
                        // console.log(res.data)
                        if(res.data)
                        {
                            this.msj_show = ' Ocurrió un error. Le pedimos vuelva a solicitar recuperar su contraseña.'
                            setTimeout(() => {
                                this.loadingMsj = false
                            }, 1000);
                            this.noShow = true
                            this.imgResultado = require('@/assets/003-cancelar.png');
                        }
                        else
                        {                            
                            setTimeout(() => {
                                this.loadingMsj = false
                            }, 1000);
                            this.noShow = false
                        }
               
                }).catch(error=>{                   
                    this.$alert('Error del servidor '+error);
                });       
    }
  },
  metaInfo() {
   return {
    title: this.titulo,
    htmlAttrs: {
      lang: 'en'
    },
    meta: [
      { charset: 'utf-8' },
      { name: 'description', content: 'An example Vue application with vue-meta.' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
    ],
    link: [
      { rel: 'stylesheet', href: 'https://fonts.googleapis.com/css?family=Roboto:300,300i,500,700,900i&display=swap' },
      // { rel: 'shortcut icon', type:'image/png', href: this.imgFavicon,},
      { rel: 'stylesheet', href: 'https://fonts.googleapis.com/css2?family=Varela+Round&display=swap'}
    ]
   }
  },
    mounted() {
         EventBus.$on("mostrarForm", () => {
             this.showForm = true;
        });
        
    },
    methods: {
        
        recuperar(formName)
        {
            this.loadin_enviar = true
            setTimeout(() => {
                this.$refs[formName].validate((valid) => {
                if (valid) 
                {
                /* Antes de enviar el cambio primero controlar que no se haya modificado el salt */
                 HTTP.post(SC_prueba+'/verificarSalt',{codigo:this.codigo}
                    ).then( res=>{
                        this.loadin_enviar = false
                        // console.log(res.data)
                        if(res.data)
                        {
                            this.msj_show = ' Ocurrió un error. Le pedimos vuelva a solicitar el cambio de contraseña.'
                            this.btnRegresar = 'pass'
                            // this.imgResultado = require('@/assets/003-cancelar.png');
                            setTimeout(() => {
                                this.noShow = false
                            }, 800);
                        }
                        else
                        {
                            setTimeout(() => {
                                this.noShow = false
                            }, 100);
                            /* Realizó el cambio */
                            HTTP.post(SC_prueba+'/resetPassword',{
                                pass:this.ruleForm.pass,
                                new_pass:this.ruleForm.checkPass,
                                codigo:this.codigo}
                            ).then( res=>{
                                // console.log('pasas',res.data)
                                this.loadin_enviar = false;
                                this.msj_error = ''
                                switch (res.data) {
                                    case 0:
                                        this.msj_error = 'Ocurrió un error interno al modificar la contraseña de su cuenta, por favor reintente más tarde.'
                                        setTimeout(() => {
                                            this.noShow = true
                                        }, 700);
                                        this.imgResultado = require('@/assets/003-cancelar.png');
                                        break;
                                    case 1:
                                        this.msj_show = 'El cambio de contraseña fue exitoso. Por favor ingrese al Sistema con su nueva contraseña.';
                                        setTimeout(() => {
                                            this.noShow = true
                                        }, 700);
                                        this.imgResultado = require('@/assets/002-comprobado-1.png');
                                        break;
                                    case 2:
                                        this.msj_error = 'Las contraseñas no coinciden';
                                        setTimeout(() => {
                                            this.noShow = true
                                        }, 700);
                                        this.imgResultado = require('@/assets/003-cancelar.png');
                                        this.btnRegresar = 'pass'
                                        break;
                                    case 3:
                                        this.msj_error = 'Las contraseñas no coinciden';
                                        setTimeout(() => {
                                            this.noShow = true
                                        }, 700);
                                        this.imgResultado = require('@/assets/003-cancelar.png');
                                        this.btnRegresar = 'pass'
                                        break;
                                    case 4:
                                        this.msj_error = ''
                                        this.noShow = false
                                        this.$notify.error({
                                            title: 'Error',
                                            message: 'La contraseña no puede ser una palabra reservada',
                                            offset: 200
                                        });
                                        this.$refs["password1"].focus()
                                        break;
                                        
                                }                      
                                
                            }).catch(error=>{
                                this.loadin_enviar = false;
                                this.$alert('Error del servidor '+error);
                            });
                        }
               
                }).catch(error=>{
                   
                    this.$alert('Error del servidor '+error);
                });    
                // Enviar la consulta de busqueda de email
                // Si existe enviar el email con los datos solicitados

                    
               
            } else {
                this.$message({
                message: 'Cuidado hay campos incompletos.',
                type: 'warning'
                });
                this.loadin_enviar = false

            }
            });
            }, 150);
        },
        regresarLink() 
        {
            this.$router.push({name:'login'})					
        },
    },
}
</script>
<style scoped>

.body-back{
    /* background: linear-gradient(96deg, #FFFAFA 0, #E5EBF6 64%); */
    overflow:hidden;  
    height: 100%;  
    text-align: center;
}
.img-banner
{
    padding-top: 20px;
    width:290px;
    padding-bottom: 20px;
}
.login {
  max-width: 450px;
  margin: 100px auto;
}
.login img {
  display: block;
  margin: 0 auto;
}
.el-card.is-always-shadow {
    box-shadow: 0 2px 12px 0 rgb(0 0 0 / 33%);
}
@media (max-width: 600px) {
  .el-card.is-always-shadow {
    margin: 15px !important;
    }   
}
.el-form-item {
    margin-bottom: 15px !important;
}
</style>
